import clsx from 'clsx';
import type * as React from 'react';

import * as api from '@gitbook/api-client';
import { isImageFile } from '@gitbook/app-database';
import { Image } from '@gitbook/spine-react';

import { useContentReference } from '../../../../../Components';
import { getImageResizedURL } from '../../../../../utils';
/**
 * Image cover rendered at the top of the card when `coverDefinition` is defined
 */
export function TableRecordCover(props: {
    coverRef: api.ContentRefFile | api.ContentRefURL;
    objectFit?: api.CardsImageObjectFit;
}): React.ReactElement | null {
    const { coverRef, objectFit = api.CardsImageObjectFit.Cover } = props;

    const resolved = useContentReference(coverRef);

    if (coverRef.kind === 'url') {
        return <ImageCover src={coverRef.url} objectFit={objectFit} />;
    }

    const file = resolved.resolution?.extra?.file;
    const imageUrl =
        resolved && file && isImageFile(file)
            ? getImageResizedURL(file.downloadURL, { width: 371 })
            : null;

    if (!imageUrl) {
        return null;
    }

    return <ImageCover src={imageUrl} objectFit={objectFit} />;
}

function ImageCover(props: {
    src: string;
    objectFit: api.CardsImageObjectFit;
}): React.ReactElement | null {
    const { src, objectFit } = props;

    const objectFitClass = {
        [api.CardsImageObjectFit.Cover]: 'object-cover',
        [api.CardsImageObjectFit.Contain]: 'object-contain',
        [api.CardsImageObjectFit.Fill]: 'object-fill',
    }[objectFit];

    return (
        <Image
            src={src}
            className={clsx('aspect-video w-full rounded-none bg-side', objectFitClass)}
            resize={{ width: 371 }}
        />
    );
}
